import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CommonService } from "src/@services/common.service";
import { CommonPagesService } from "../../common-pages.service";
import { responseMessageStatus, ResponseStatus } from "../../enum";

@Component({
  selector: "app-changepassword",
  templateUrl: "./changepassword.component.html",
  styleUrls: ["./changepassword.component.scss"],
  standalone: false,
})
export class ChangepasswordComponent implements OnInit {
  //#region properties
  @Output() hideChangePassword = new EventEmitter();
  isVisibleChangePassword: boolean = true;
  changePasswordForm: FormGroup;
  currentPassword: string;
  passwordVisible = false;
  npasswordVisible = false;
  cpasswordVisible = false;
  isSubmitting: boolean = false;
  //#endregion

  //constructor
  constructor(
    private fb: FormBuilder,
    private _cS: CommonService,
    private _cpS: CommonPagesService
  ) {}

  //#region functions
  ngOnInit(): void {
    this.changePasswordForm = this.fb.group({
      oldPassword: [null, [Validators.required]],
      password: [null, [Validators.required]],
      confirmPassword: [
        null,
        [Validators.required, this.confirmationValidator],
      ],
    });
  }
  updateConfirmValidator(): void {
    /** wait for refresh value */
    setTimeout(() =>
      this.changePasswordForm?.controls[
        "confirmPassword"
      ].updateValueAndValidity()
    );
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (
      control.value !== this.changePasswordForm?.controls["password"].value
    ) {
      return { confirm: true, error: true };
    }
    return {};
  };
  changePasswordSubmit() {
    this.isVisibleChangePassword = false;
    this.hideChangePassword.emit({
      hide: this.isVisibleChangePassword,
      data: null,
    });
  }
  updatePassword() {
    if (this.changePasswordForm?.valid) {
      this.isSubmitting = true;
      const passwordBody = {
        oldPassword: this.changePasswordForm.value.oldPassword,
        password: this.changePasswordForm.value.password,
        confirmPassword: this.changePasswordForm.value.confirmPassword,
      };
      this._cpS.changePassword(passwordBody).subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.cancelUpdatePassword();
            this.isSubmitting = false;
            this.currentPassword =
              this.changePasswordForm.value.confirmPassword;
            this._cS.displayMessage(
              responseMessageStatus.success,
              response.message
            );
          } else {
            this.isSubmitting = false;
            this._cS.displayMessage(
              responseMessageStatus.error,
              response.message
            );
          }
        },
        (error: any) => {
          this._cS.displayMessage(responseMessageStatus.error, error.message);
        }
      );
    } else {
      this._cS.markFormGroupTouched(this.changePasswordForm);
    }
  }
  cancelUpdatePassword() {
    this.isVisibleChangePassword = false;
    this.hideChangePassword.emit({
      hide: this.isVisibleChangePassword,
      data: null,
    });
    this.changePasswordForm.reset();
  }
  //#endregion
}
